export const gitVersion = {
  "commit": "f005bce",
  "commitLong": "f005bce8e2ae67d0af24c0f8a16ab417925706a1",
  "date": "2026-06-01T19:24:19.000Z",
  "buildNumber": "10"
}